import PageGuide from "@/components/PageGuide";

export default function PageHeader({ overline, title, subtitle, action, kicker, guideId }) {
  return (
    <header className="px-8 pt-8 pb-6 border-b theme-border flex items-end justify-between gap-4 flex-wrap">
      <div className="min-w-0">
        {overline && <div className="overline">{overline}</div>}
        <h1 className="font-serif-display text-4xl sm:text-5xl theme-ink mt-2 leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="theme-ink-muted text-sm mt-2 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
        <div className="flex items-center gap-3 mt-3 flex-wrap">
          {kicker && <div className="text-xs font-mono-data theme-ink-dim">{kicker}</div>}
          {guideId && <PageGuide pageId={guideId} />}
        </div>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
